import Layout from '@/views/layout/Main'
// const Empty = () => import(`@core/router/Empty.vue`)
const NotFound = () => import(`@core/router/NotFound.vue`)
const mainRoutes = [
  {
    path: '/',
    name: 'mainRoute',
    component: Layout,
    meta: {
    },
    children: []
  },
  {
    path: '/application',
    name: 'application',
    component: Layout,
    meta: {},
    children: []
  },
  {
    path: '*',
    name: 'notfound',
    component: NotFound
  }
]

export default mainRoutes



// WEBPACK FOOTER //
// ./src/area-core/router/mainRoutes.js